import { SVGProps } from 'react';

const CopyClipBoardIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg {...props} viewBox="0 0 25 28" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M16.6667 1.6129H4.83871C3.05715 1.6129 1.6129 3.05715 1.6129 4.83871V18.5484C1.6129 20.33 3.05715 21.7742 4.83871 21.7742H16.6667C18.4482 21.7742 19.8925 20.33 19.8925 18.5484V4.83871C19.8925 3.05715 18.4482 1.6129 16.6667 1.6129ZM4.83871 0C2.16636 0 0 2.16637 0 4.83871V18.5484C0 21.2207 2.16636 23.3871 4.83871 23.3871H16.6667C19.339 23.3871 21.5054 21.2207 21.5054 18.5484V4.83871C21.5054 2.16636 19.339 0 16.6667 0H4.83871Z"
      fill="#F5F6FF"
    />
    <rect
      x="4.83868"
      y="5.64532"
      width="19.3548"
      height="20.9677"
      rx="4.03226"
      fill="#162638"
      stroke="#F5F6FF"
      strokeWidth="1.6129"
    />
  </svg>
);

export default CopyClipBoardIcon;
